import { Pipe, PipeTransform } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

@Pipe({
  name: 'doc',
  standalone: false,
})
export class DocPipe implements PipeTransform {

  constructor(
    private angularFirestore: AngularFirestore
  ) {}

  transform(value: string, collectionName: string): Observable<any> {
    return this.angularFirestore.doc(`${collectionName}/${value}`).valueChanges();
  }

}
